<script lang="ts">
  /**
   * ModexpFigure — the top-level animated figure for the Modular Exponentiation
   * section. Materializes the generator, hands the steps to the AlgorithmPlayer,
   * and supplies the per-step Visual component via the player's snippet slot.
   */
  import { repeatedSquaring } from './algorithm';
  import { makeModexpDescriber } from './describe';
  import type { ModexpInputs, ModexpStep } from './types';
  import { materialize } from '../../animation/runner';
  import type { StepEnvelope } from '../../animation/types';
  import AlgorithmPlayer from '../../animation/AlgorithmPlayer.svelte';
  import Visual from './Visual.svelte';

  type Props = {
    /** Default: 415^22 mod 601 — chosen to match a real probe in our trace data. */
    inputs?: ModexpInputs;
  };

  const defaultInputs: ModexpInputs = {
    base: 415n,
    exp: 22n,
    mod: 601n,
  };

  let { inputs = defaultInputs }: Props = $props();

  const steps: ReadonlyArray<StepEnvelope<ModexpStep>> = $derived(
    materialize(repeatedSquaring(inputs), makeModexpDescriber(inputs))
  );
</script>

<AlgorithmPlayer {steps}>
  {#snippet visual(envelope: StepEnvelope<ModexpStep>)}
    <Visual step={envelope.step} {inputs} />
  {/snippet}
</AlgorithmPlayer>
